import { useRef } from 'react';
import { Policy } from '../../types/policy.types';
import { DocumentViewerBase } from '../Viewers/DocumentViewerBase';
import { RichTextEditor } from './RichTextEditor';
import { PolicyEditorInputs } from './PolicyEditorInputs';
import { usePolicyEditorState } from '../../hooks/usePolicyEditorState';

interface PolicyEditorProps {
	policy: Policy | null;
	onChange?: (updatedPolicy: Partial<Policy>) => void;
}

export const PolicyEditor = ({ policy, onChange }: PolicyEditorProps) => {
	const scrollContainerRef = useRef<HTMLDivElement | null>(null);

	const {
		title,
		description,
		content,
		version,
		effectiveDate,
		handleTitleChange,
		handleDescriptionChange,
		handleContentChange,
		handleVersionChange,
		handleEffectiveDateChange,
	} = usePolicyEditorState(policy, onChange);

	if (!policy) {
		return <DocumentViewerBase isEmpty={true} emptyMessage="Selecione uma política para editar" />;
	}

	return (
		<DocumentViewerBase scrollContainerRef={scrollContainerRef}>
			<PolicyEditorInputs
				title={title}
				description={description}
				version={version}
				effectiveDate={effectiveDate}
				isActive={policy.isActive}
				lastEditedAt={policy.updatedAt}
				onTitleChange={handleTitleChange}
				onDescriptionChange={handleDescriptionChange}
				onVersionChange={handleVersionChange}
				onEffectiveDateChange={handleEffectiveDateChange}
			/>

			<RichTextEditor
				value={content}
				onChange={handleContentChange}
				placeholder="Escreva o conteúdo da política..."
			/>
		</DocumentViewerBase>
	);
};
